'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feedback = function Feedback(_ref) {
    var closeFeedback = _ref.closeFeedback,
        theme = _ref.theme,
        settings = _ref.settings,
        children = _ref.children;

    var showCloseButton = function showCloseButton() {
        if (settings.showCloseButton) {
            return _react2.default.createElement(
                'button',
                { onClick: closeFeedback },
                settings.closeButtonText
            );
        }
        return null;
    };

    return _react2.default.createElement(
        'div',
        { className: theme.wrapper },
        _react2.default.createElement(
            'span',
            null,
            children
        ),
        showCloseButton()
    );
};

Feedback.propTypes = {
    children: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    closeFeedback: _propTypes2.default.func.isRequired,
    settings: _propTypes2.default.shape({
        closeButtonText: _propTypes2.default.string,
        showCloseButton: _propTypes2.default.bool,
        persistentHide: _propTypes2.default.bool
    }),
    theme: _propTypes2.default.shape({
        wrapper: _propTypes2.default.string
    }).isRequired
};

Feedback.defaultProps = {
    settings: {}
};

exports.default = Feedback;
//# sourceMappingURL=Feedback.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/feedback/lib/cjs/FeedbackWidget/Feedback.js
 ** module id = 724
 ** module chunks = 1
 **/